import React from 'react'

import NavButton from '../NavButton/NavButton'
import Logo from '../Logo/Logo'
import Burger from '../Burger/Burger'

import './Navigation.css'

const Navigation = ({ burgerOpen, handleBurgerCLick }) => (
  <div
    className={
      'fmbm-navigation' + (burgerOpen ? ' fmbm-navigation--fullscreen' : '')
    }
  >
    <div className="fmbm-navigation__container">
      <a href="/">
        <Logo />
      </a>
      <div
        className="fmbm-navigation__buttons"
        onClick={() => {
          if(window.innerWidth < 767)
            handleBurgerCLick()
        }}
      >
        <NavButton text="Home" />
        <NavButton text="Services" path={'/services'} />
        <NavButton text="About" path={'/aboutus'} />
        <NavButton
          text="Contact"
          cta={true}
          new
          path="https://goo.gl/forms/Ic1vg0nIpl8qfdi22"
        />
      </div>
      <Burger burgerOpen={burgerOpen} handleBurgerCLick={handleBurgerCLick} />
    </div>
  </div>
)

export default Navigation



// WEBPACK FOOTER //
// ./src/Components/Navigation/Navigation.js